import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useLanguage } from "../../LanguageProvider";
import Header from "../Reutilizables/Header/Header";
import Footer from "../Reutilizables/Footer/Footer";
import Hero from "../Reutilizables/Hero/Hero";
import consecutiveImg from "../../assets/consecutive interpretation.jpeg";
import simultaneousImg from "../../assets/simultaneous interpretation.jpeg";
import translationImg from "../../assets/translation.jpeg";
import sightImg from "../../assets/sight translation.jpeg";
import chuchotageImg from "../../assets/chuchotage.jpeg";
import equipmentImg from "../../assets/equipment rental.jpeg";
import "./Services.css";

const highlightUSCIS = (text) => text.split(/(USCIS)/g).map((part, index) => (
  part === "USCIS" ? <strong className="service-card__highlight" key={index}>{part}</strong> : part
));

function Services() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { t } = useTranslation();
  const { language } = useLanguage();

  const services = [
    { title: t("servicesTextTitle2"), text: t("servicesText2"), image: consecutiveImg, icon: "bi-people" },
    { title: t("servicesTextTitle1"), text: t("servicesText1"), image: simultaneousImg, icon: "bi-mic" },
    { title: t("servicesTitleTranslation"), text: t("servicesTextTranslation"), image: translationImg, icon: "bi-file-earmark-text" },
    { title: t("servicesTextTitle3"), text: t("servicesText3"), image: sightImg, icon: "bi-eye" },
    { title: t("servicesTextTitle4"), text: t("servicesText4"), image: chuchotageImg, icon: "bi-ear" },
    { title: t("servicesTextTitle5"), text: t("servicesText5"), image: equipmentImg, icon: "bi-headphones" },
  ];

  return (
    <div className="app-shell services-page">
      <Header />
      <main className="page-main">
        <Hero compact className="services-hero" />
        <section className="services-section">
          <div className="lh-container">
            <h1 className="section-title">{language === "en" ? "SERVICES" : "SERVICIOS"}</h1>
            <p className="section-subtitle">{language === "en" ? "Professional language solutions, on-site and remote." : "Soluciones profesionales de idiomas, presenciales y remotas."}</p>
            <div className="services-grid">
              {services.map((service) => (
                <article className="service-card" key={service.title}>
                  <img src={service.image} alt="" className="service-card__image" />
                  <div className="service-card__body">
                    <i className={`bi ${service.icon} service-card__icon`} aria-hidden="true" />
                    <div className="service-card__copy">
                      <h2>
                        {service.title.startsWith("CHUCHOTAGE") ? (
                          <>
                            {service.title.split(" (")[0]}
                            <br />
                            ({service.title.split(" (")[1]}
                          </>
                        ) : service.title}
                      </h2>
                      <p>{service.title === t("servicesTextTitle2") ? highlightUSCIS(service.text) : service.text}</p>
                      <Link className="service-card__learn" to="/contact">{t("learnMore")} →</Link>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Services;
